export interface DeviceModel {
  readonly id: string;
  readonly name: string;
  readonly family: string;
}

export const enumDeviceFamily = {
  TETRA: 'TETRA',
  AXIUM: 'AXIUM',
  TYRO: 'TYRO',
  YOXIMO: 'YOXIMO',
  AXIUM_NG: 'AXIUM NG',
  AXIUM_GMS: 'AXIUM GMS',
} as const;

export const validDeviceFamilyForHardwareFields: string[] = Object.values(enumDeviceFamily);

export const validDeviceFamilyForAutofill: string[] = [
  enumDeviceFamily.AXIUM,
  enumDeviceFamily.AXIUM_NG,
  enumDeviceFamily.AXIUM_GMS,
];

export const validDeviceFamilyForModelFetch: string[] = [
  enumDeviceFamily.TYRO,
  enumDeviceFamily.TETRA,
  enumDeviceFamily.YOXIMO,
];

export const deviceManufacturersWithRequiredModelFieldInCreation: string[] = ['worldline', 'tyro'];
